import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { boardEmbedEntryPoint } from '@atlassian/jira-spa-apps-business-board-embed/entrypoint.tsx';

export const boardEmbedPageEntryPoint = createChromelessEntryPoint({
	main: boardEmbedEntryPoint,
});
